import { db } from '../../firebase'
import clientsCollection from '../firestore/client'

const bookings = db.collection('bookings')
const clients = db.collection('clients')

export default {
  index() {
    const data = []
    bookings.get().then(docs => {
      docs.forEach((doc) => {
        clients.doc(doc.data().client_id).get().then((clientDoc) => {
          data.push({
            id: doc.id,
            details: doc.data().details,
            client_name: clientDoc.data().name
          })
        })
      })
    })

    return data
  },
  show(id) {
    return bookings.doc(id).get()
  },
  create(params) {
    if (params.client_id !== undefined) {
      return bookings.add(params)
    } else {
      return clients.where("name", "==", params.client.name).where("contact_number", "==", params.client.contact_number).limit(1).get().then((querySnapshot) => {
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          return bookings.add(Object.assign(params.booking, { client_id: doc.id }))
        })
      } else {
        return Promise.resolve(
          clientsCollection.create(params.client).then((doc) => {
            return bookings.add(Object.assign(params.booking, { client_id: doc.id }))
          }).catch(err => {
            throw err
          })
        )
      }
    })
    }
  },
  update(params) {
    return bookings.doc(params.id).set(params)
  },
  delete(id) {
    return bookings.doc(id).delete()
  }
}